var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 90,
    viewBox: "0 0 360 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_530_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.82 -100C195.639 -99.9999 217.707 -94.5883 235.799 -85.375C244.551 -86.975 253.717 -87.8252 263.157 -87.8252C285.921 -87.8252 307.086 -82.8817 324.709 -74.4014C335.994 -77.1883 348.096 -78.7012 360.688 -78.7012C422.079 -78.7012 471.846 -42.7543 471.846 1.58789C471.845 45.9298 422.079 81.876 360.688 81.876C337.925 81.876 316.76 76.9316 299.137 68.4512C287.852 71.2381 275.749 72.752 263.157 72.752C239.338 72.752 217.269 67.3389 199.177 58.125C190.425 59.7248 181.26 60.5771 171.82 60.5771C162.702 60.5771 153.84 59.7837 145.36 58.2881C126.531 68.8708 102.863 75.1748 77.1572 75.1748C15.7671 75.1748 -33.9996 39.2287 -34 -5.11328C-34 -49.4555 15.7668 -85.4023 77.1572 -85.4023C86.2753 -85.4023 95.1369 -84.609 103.617 -83.1133C122.447 -93.696 146.114 -100 171.82 -100Z",
    fill: "url(#paint0_linear_530_143)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_530_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 27.6693C307.556 32.1036 327.51 42.239 340.813 60.9262",
    stroke: "#FFEBA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.243 35.9044C336.095 37.8392 342.078 46.9586 341.267 52.9507",
    stroke: "#FFEBA9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.898 18.634C316.631 17.1475 318.751 17.1475 319.485 18.634L319.925 19.5268C320.217 20.1171 320.78 20.5263 321.431 20.6209L322.417 20.7641C324.057 21.0025 324.712 23.0184 323.525 24.1755L322.812 24.8705C322.341 25.33 322.126 25.992 322.237 26.6408L322.405 27.6221C322.685 29.2559 320.97 30.5019 319.503 29.7305L318.622 29.2671C318.039 28.9608 317.343 28.9608 316.761 29.2671L315.879 29.7305C314.412 30.5019 312.697 29.2559 312.977 27.6221L313.146 26.6408C313.257 25.992 313.042 25.33 312.57 24.8705L311.857 24.1755C310.67 23.0184 311.325 21.0025 312.966 20.7641L313.951 20.6209C314.603 20.5263 315.166 20.1171 315.457 19.5268L315.898 18.634Z",
    fill: "#FFEBA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.924 24.18C336.499 23.0161 338.158 23.0161 338.733 24.18C338.961 24.6422 339.402 24.9625 339.912 25.0367C341.196 25.2233 341.709 26.8018 340.78 27.7077C340.411 28.0675 340.242 28.5858 340.329 29.0938C340.549 30.3731 339.206 31.3486 338.057 30.7446C337.601 30.5048 337.056 30.5048 336.6 30.7446C335.451 31.3486 334.108 30.3731 334.328 29.0938C334.415 28.5858 334.246 28.0675 333.877 27.7077C332.948 26.8018 333.461 25.2233 334.745 25.0367C335.255 24.9625 335.696 24.6422 335.924 24.18Z",
    fill: "#FFEBA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_530_143",
    x: -38,
    y: -100,
    width: 513.846,
    height: 189.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_530_143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_530_143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_530_143",
    x: 278,
    y: 17.5191,
    width: 64.8419,
    height: 49.4072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_530_143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_530_143",
    x1: 459.2,
    y1: 278.908,
    x2: -17.0965,
    y2: 119.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC982"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBanner);
export default __webpack_public_path__ + "static/media/notification-banner.7bbc970c6270a3db736b12bbbdbfcab2.svg";
export { ForwardRef as ReactComponent };